module.exports = __webpack_public_path__ + "img/palmar-room-11.dc615938.jpg";